import { User } from "../Auth/AuthProvider";

 export const isEmailInWhitelist = (whiteList: string, user: User| null): boolean => {
        // No need to continue if whiteList is empty
        const whitelistArray: string[] | undefined = window?.config?.CREDENTIALS?.[whiteList];
        if (!Array.isArray(whitelistArray) || whitelistArray.length === 0) {
            //  console.warn(`Whitelist "${whiteList}" is not defined or is not an array => grant access to all users`);
              return true;
        }
        const email = user?.email || null;
        if (!email) {
            console.warn("No email found for this user.");
            return false;
        }
        return whitelistArray.includes(email);
    };